import { isEmpty } from 'utils/types';
import { createSelector } from 'reselect';
import paymentConstants from 'utils/paymentData/constants';

const getAuthFromLocalStorage = () => {
  try {
    const auth = window?.localStorage?.getItem('auth');
    return auth ? JSON.parse(auth) : null;
  } catch {
    return null;
  }
};

const getAuthError = (state) => state.auth.error;
const userIsLogged = (state) =>
  !isEmpty(state.auth.credentials) || !isEmpty(getAuthFromLocalStorage());
const isAuthenticating = (state) => state.auth.loading;
const getCredentials = (state) =>
  getAuthFromLocalStorage() || state.auth.credentials;
const getAccessToken = (state) =>
  (getCredentials(state) && getCredentials(state).access_token) || null;
const getAuthHeader = (state) =>
  (getCredentials(state) &&
    `${getCredentials(state).token_type} ${
      getCredentials(state).access_token
    }`) ||
  null;
const getUser = (state) => state?.auth?.user || {};
const getUserShipper = (state) => state?.auth?.user?.shipper;
const getShipper = (state) => state?.auth?.shipper;
const getUserPaymentMethod = (state) =>
  state?.auth?.user?.shipper_payment_method;

const getUserShipperTaxNumber = (state) =>
  state?.auth?.user?.shipper_tax_number;

const getUserShipperId = (state) => state?.auth?.user?.shipper_id;

const getUsersInShipper = (state) => state?.auth?.user?.shipper_users;

const getUserAcceptedTerms = (state) => state?.auth?.user?.accepted_terms;

const getCommercialCommunicationsAccepted = (state) =>
  state?.auth?.user?.commercial_communications_accepted;

const getPaymentDataPaymentMethodValidationStatus = (state) =>
  state?.auth?.user?.shipper_payment_method_validation_status;

const getPaymentDataAllowShipperDoShipments = (state) => {
  const userState = state?.auth?.user;
  const paymentMethod = userState?.shipper_payment_method;
  const validationStatus = userState?.shipper_payment_method_validation_status;
  const numberOfShipments = userState?.shipper_number_of_shipments;
  const limitOfShipments = state?.settings?.country?.ftb_validating_limit || 1;
  if (paymentMethod === paymentConstants.PAYMENT_METHODS.CARD) {
    return true;
  }
  if (
    validationStatus !== 'VALIDATED' &&
    numberOfShipments >= limitOfShipments
  ) {
    return false;
  }
  return true;
};

const getUserPreferences = createSelector(getUser, (user) => user?.preferences);

const getIsCoreNonCoreEnabled = createSelector(
  getUser,
  (user) => user?.core_non_core_enabled
);

const getUserPreferencesCampaigns = createSelector(
  getUserPreferences,
  (userPreferences) => userPreferences?.campaigns
);

const getSuperSetAuth = (state) => state?.auth?.user?.superset_auth;

const getUserPermissions = (state) => state?.auth?.user?.user_permissions || [];

const getCurrentTermsAndConditionsVersion = (state) =>
  state?.auth?.user?.current_terms_and_conditions_version;

export default {
  getAuthError,
  userIsLogged,
  isAuthenticating,
  getCredentials,
  getAccessToken,
  getAuthHeader,
  getUser,
  getUserShipper,
  getShipper,
  getUserPaymentMethod,
  getUserShipperTaxNumber,
  getUserShipperId,
  getUsersInShipper,
  getUserAcceptedTerms,
  getCommercialCommunicationsAccepted,
  getPaymentDataPaymentMethodValidationStatus,
  getPaymentDataAllowShipperDoShipments,
  getUserPreferences,
  getUserPreferencesCampaigns,
  getSuperSetAuth,
  getIsCoreNonCoreEnabled,
  getUserPermissions,
  getCurrentTermsAndConditionsVersion,
};
